import { DifferencesContainer, Industries, Plus, PlusSection, IndustriesSection } from './style';
import Title from '../Title';
import Reveal from '../Reveal';
import IndustryCard from '../IndustryCard';
import { INDUSTRIES, PLUS_FEATURES, COMPANY_NAME } from '../../constants';
import { CheckCircle } from 'react-bootstrap-icons';

const Differences = () => {
  return (
    <DifferencesContainer id="differences">
      <PlusSection>
        <Reveal>
          <Title
            title="Nosso Plus: Consultoria jurídica Especializada"
            subtitle={`Além da gestão completa de RH, a ${COMPANY_NAME} oferece suporte jurídico personalizado, garantindo conformidade com a legislação trabalhista e segurança total nos processos.`}
          />
          <Plus>
            {PLUS_FEATURES.map((feature) => (
              <div key={feature} className="plus-card">
                <div className="icon-wrapper">
                  <CheckCircle />
                </div>
                <p>{feature}</p>
              </div>
            ))}
          </Plus>
        </Reveal>
      </PlusSection>

      <IndustriesSection>
        <Reveal>
          <Title title={`Setores que confiam na ${COMPANY_NAME}`} />
          <Industries>
            {INDUSTRIES.map((industry) => (
              <IndustryCard key={industry.id} title={industry.title} Icon={industry.Icon} />
            ))}
          </Industries>
          <Title title='' subtitle='Atuamos com empresas que buscam regularidade trabalhista e eficiência operacional em todos os
            processos de RH.' />
        </Reveal>
      </IndustriesSection>
    </DifferencesContainer>
  );
};

export default Differences;